import { QRCodeCanvas } from 'qrcode.react';
import { Wrapper } from './QrCode.style';

export type QrCodeProps = {
  value: string;
};

export function QrCode(props: QrCodeProps) {
  const { value } = props;

  return (
    <Wrapper className='QrCode-wrapper' data-testid='QrCode-wrapper'>
      <QRCodeCanvas value={value} size={256} />
    </Wrapper>
  );
}

export default QrCode;
